<div class="sidebar">
  <nav *ngIf="genres">
    <h3>Movies by Genre</h3>
    <div *ngFor="let genre of genres.genres">
      <a
        [routerLink]="['/genre', genre.name, genre.id]"
        routerLinkActive="active"
        >{{ genre.name }}</a
      >
    </div>
  </nav>

  <a href="https://github.com/r-shafi/film-finder.git" target="_blank">
    Code on Github
  </a>
</div>
